type Mirror<T> = { [P in keyof T]: string }

export function keyMirror<T extends {}>(keys: T, namespace?: string): Mirror<T> {
  const outputKeys = {}

  Object.keys(keys).forEach((key) => {
    if (namespace) {
      // @ts-expect-error
      outputKeys[key] = `${key}@${namespace}`
    } else {
      // @ts-expect-error
      outputKeys[key] = key
    }
  })

  return outputKeys as Mirror<T>
}
